const API = require('../models/API')
const config = require('../config/config')
const AppError = require('../config/Errors')
const appUtils = require('../common/appUtils')

var User = function (APP_NAME, NODE_ENV, Store, Helper) {
	this.APP_NAME = APP_NAME
	this.NODE_ENV = NODE_ENV
	this.Store = Store
	this.ApiInterface = new API(this.APP_NAME, this.NODE_ENV)
	this.errArr = []
	this.Helper = Helper
}


User.prototype.getBase64Media = function (userProps, media, Callback) {
	var self = this
	// 
  return this.ApiInterface.getBase64Media(media.media_id, userProps.token, function (ApiErr, respStatus, base64Media) {
	if ((respStatus >= 400 && respStatus < 500) || ApiErr) {
		delete userProps.token
		if (ApiErr) {
			console.log(ApiErr)
		}
		return self.Store.setUserProperties(userProps, function (err, success) {
			if (err) {
				console.error(err)
			}
			return Callback(err)
		})
	}
    return Callback(null, base64Media)
  })
}


User.prototype.saveMedia = function (messageProps, Callback) {
	var self = this
	return this.getProperties(function (err, userProps) {
		if (err) {
			console.error(err)
			return Callback(err)
		}
		if (!userProps || !userProps.token) {
			return Callback('Forbidden')
		}
		// 
		let media = {
			userId: userProps.appData.user_id,
			templateId: messageProps.templateId,
			imageInput: messageProps.fullStyle.imageInput.content,
			finalMessage: messageProps.finalMessage,
			title: messageProps.fullStyle.title.html,
			mainText  : messageProps.fullStyle.mainText.html
		};
		// 
		return self.ApiInterface.saveUserMedia(media, userProps.token, function (ApiErr, httpStatus, response) {
			if ((httpStatus >= 400 && httpStatus < 500) || ApiErr) {
				delete userProps.token
				if (ApiErr) {
					console.log(ApiErr)
					return Callback(ApiErr, httpStatus, userProps)
				}
				return self.Store.setUserProperties(userProps, function (err, success) {
					if (err) {
						console.error(err)
					}
					return Callback(err, httpStatus, userProps)
				})
			}
			// 
			self.userProperties = response
			if(userProps && response && response.data && response.data.token) {
				return self.Store.setUserProperties(response.data, function (err, success) {
					if (err) {
						console.error(err)
					}
					return Callback(null, httpStatus, response.data)
				}) 
			}
			return Callback('Erreur inconnue', httpStatus)
		})
	})
};


User.prototype.saveMessages = function (rediectURI, router, userProps) {
	var self = this, medias = [];
	this.Helper.backdrop.show('#app')
	// 
	return this.Store.setUserProperties(userProps, function (err, success) {
		if (err) {
			self.Helper.backdrop.hide('#app')
			console.error(err)
		}
		// ------------------------------
		const user = JSON.parse(JSON.stringify(userProps));
		!! user
			&& user.appData
			&& !!user.appData.medias
			&& user.appData.medias.length
			&& user.appData.medias
			&& (medias = appUtils.deHostify(user.appData.medias, self.NODE_ENV))
			&& !!medias
			&& (user.appData.medias = medias);
		// 
		return self.ApiInterface.saveDiffusion(user, function (ApiErr, respStatus, respData) {
			if ((respStatus >= 400 && respStatus < 500) || ApiErr) {
				delete userProps.token
				if (ApiErr) {
					self.Helper.backdrop.hide('#app')
					console.log(ApiErr)
				}
				return self.Store.setUserProperties(userProps, function (err, success) {
					if (err) {
						self.Helper.backdrop.hide('#app')
						console.error(err)
					}
					// 
					if (router) {
						return router.replace('/')
					}
					// 
					return window.location.replace('/')				
				})
			}
			// 
			if (rediectURI) {
				self.Helper.backdrop.hide('#app')
				if (router) {
					return router.replace('/app/confirmation')
				}
				return window.location.replace('/app/confirmation')
			}
			self.Helper.backdrop.hide('#app')
			let modalButton = document.querySelector('#modal2Button')
			modalButton.click()
		});
	})
};


User.prototype.suppressMedia = function (media, router, Callback) {
	var self = this
	// 
	try {
		return this.getProperties(function (err, userProps) {
			if (err) {
				self.Helper.backdrop.hide('#app')
				console.error(err)
				delete userProps.token
				if (router) {
					return router.replace('/')
				}
				return window.location.replace('/')
			}
			// 
			self.Helper.backdrop.show('#app')
			return self.ApiInterface.suppressUserMedia(media, userProps, function (ApiErr, respStatus, respData) {
				if ((respStatus >= 400 && respStatus < 500) || ApiErr) {
					delete userProps.token
					if (ApiErr) {
						self.Helper.backdrop.hide('#app')
						console.log(ApiErr)
					}
					return self.Store.setUserProperties(userProps, function (err, success) {
						if (err) {
							self.Helper.backdrop.hide('#app')
							console.error(err)
						}
						self.Helper.backdrop.hide('#app')
						if (router) {
							return router.replace('/')
						}
						return window.location.replace('/')
					})
				}
				//
				delete media
				self.userProperties = respData
				if(userProps && respData && respData.data && respData.data.token) {
					return self.Store.setUserProperties(respData.data, function (err, success) {
						if (err) {
							self.Helper.backdrop.hide('#app')
							console.error(err)
						}
						self.Helper.backdrop.hide('#app')
						return Callback(null, respStatus, respData.data)
					}) 
				}
				self.Helper.backdrop.hide('#app')
				return Callback('Erreur inconnue', respStatus)
			})
		})
	} catch (err) {
		self.Helper.backdrop.hide('#app')
		console.error(err)
	}
}

User.prototype.disconnect = function (router, delay) {
	// new method :
	// verbe delete http avec token en parametre
	// 
	var self = this
	this.router = router
	if (!delay) {
		delay = 0
	}
	try {
		return this.getProperties(function (err, userProps) {
			if (err) {
				console.error(err)
			}
			// 
			if (userProps && userProps.token) {
				return self.ApiInterface.disconnect(userProps.token, function (err, respStatus) {
					if (err) {
						console.error(err)
					}
					if (respStatus != 200) {
						console.log(respStatus)
					}
					self.setConnectionStatus(false)
					setTimeout(function () {
						delete userProps.token
						return self.Store.dropProperties(function (err, success) {
							if (err) {
								console.error(err)
							}
							if (self.router) {
								return self.router.replace('/')	
							}
							window.location.replace('/')
						})
					}, delay)
				})
			} else {
				self.setConnectionStatus(false)
				setTimeout(function () {
					return self.Store.dropProperties(function (err, success) {
						if (err) {
							console.error(err)
						}
						if (self.router) {
							return self.router.replace('/')	
						}
						window.location.replace('/')
					})
				}, delay)
			}
		})
	} catch (err) {
		console.error(err)
	}
};


User.prototype.setDomElements = function (domElements, router) {
	var self = this
	var submitAction = function (e) {
		e.preventDefault()
	  return self.authenticate(function (err, userProps) {
	    if (err) {
	      console.error(err)
	    }
	    if (userProps) {
	      return self.Store.setUserProperties(userProps, function (err, success) {
	      	if (err) {
	      		console.error(err)
	      	}
	      	if (success) {
	      		self.domElements.showModalButton.click()
	      		self.domElements.approveCGU.addEventListener('click', function (e) {
	      			self.Store.set('cgu', 1)
	      			if (self.router) {
	      				return self.router.replace('/app/home')
	      			}
	      			return window.location.replace('/app/home')
	      		}, false)
	      	}
	      })
	    }
	    return false
	  })
	}
	this.router = router
	this.domElements = domElements
	if (domElements.submit) {
		domElements.submit.addEventListener('click', submitAction)
	}
}


User.prototype.getProperties = function (Callback) {
	return this.Store.retrieveUserProperties(function (err, userProps) {
		if (err) {
			return Callback(err)
		}
		return Callback(null, userProps)
	})
};


User.prototype.checkInputs = function () {
	this.domElements.errModalContent.innerHTML = ''
	var conditions = {
		login: (this.domElements.login.value.length != 0) ? 1 : 'Veuillez saisir votre nom d\'utilisateur',
		password: (this.domElements.password.value.length != 0) ? 1 : 'Veuillez saisir votre mot de passe',
		loginLength: (this.domElements.login.value.length > 150) ? 'Une erreur est survenue' : 1,
		passWordLength: (this.domElements.password.value.length > 150) ? 'Une erreur est survenue' : 1
	}
	for (var i in conditions) {
		if (conditions[i] !== 1) {
			this.errArr.push(conditions[i])
		}
	}
	if (this.errArr.length > 0 && this.domElements.errModalContent) {
		for (var i in this.errArr) {
			AppError.throwErrorModal (this.errArr, this.domElements.errModalContent, this.domElements.modalButton)
		}
		this.errArr = []
		return false
	}
	return true
}


User.prototype.authenticate = function (Callback) {
	var self = this
	var credentials = {
		login: this.domElements.login.value,
		password: this.domElements.password.value
	}
	this.errArr = []
	if (this.checkInputs()) {		
		return new Promise (function (resolve, reject) {
			return self.ApiInterface.authenticate(credentials, function (err, status, properties) {
				console.log(err, status, properties);
				if (err && err.response && err.response.status  && (err.response.status == 403 || err.response.status == 400)) {
					err = new AppError.InvalidCredentialsError('Votre identifiant ou votre mot de passe est erroné.<br/>Merci de rééssayer.')
		   			console.log('status', err.stack)
		   			self.errArr.push(err.message)
		   			AppError.throwErrorModal (self.errArr, self.domElements.errModalContent, self.domElements.modalButton)
		        	return reject(err)
				}
				if(!status) {
					err = new AppError.NetworkError('Une erreur est survenue,<br/>veuillez réessayer plus tard.')
			   		self.errArr.push(err.message)
			   		AppError.throwErrorModal (self.errArr, self.domElements.errModalContent, self.domElements.modalButton)
		        	return reject(err);
		        }
		    	if (err) {
					return reject(err)
				}
				if (properties.error) {
					return reject(properties.error)	
				}
				if (status !== 200) {
					return reject(false)
				}
				if (properties.body) {
					return resolve(properties.body)
				}
				return reject()
			})
		}).then (function (properties) {
			self.setConnectionStatus(true)
			return Callback(null, properties)
		}).catch (function (err) {
			console.error(err)
			return Callback(err)
		})
	}
}

User.prototype.setConnectionStatus = function (connectionStatus) {
	this.Store.set('connectionStatus', connectionStatus)
}


User.prototype.getConnectionStatus = function (Callback) {
	var self = this
	if (parseInt(this.Store.get('cgu')) == 1 && this.Store.get('connectionStatus') == true) {
		return Callback(null, true)
	}
	return Callback(null, false)
}


User.prototype.verify = function (to, from, Callback) {
	var self = this
	var path = to.path
	var userProperties = {}
	var isApp = /^\/app\//.test(path);
	try {
		if (isApp) {
			return this.getProperties(function (err, userProps) {
				if (err) {
					console.error(err)
					self.setConnectionStatus(false)
					return Callback(err, false)
				}
				// console.log(userProps);
				userProperties = userProps
				if (!userProperties || !userProperties.token) {
					self.setConnectionStatus(false)
					console.error('cannot find token /////////////////////////////////////////////////////');
					return Callback('Forbidden', false)
				}
				var token = userProperties.token
				return self.ApiInterface.verify(token, function (err, respStatus, respData) {
					if (err) {
						console.error(err)
						self.setConnectionStatus(false)
						return Callback(err, false)
					}
					if (respStatus != 200) {
						console.log(respStatus)
						self.setConnectionStatus(false)
						return Callback(respStatus, false)
					}
					if (!respData.body || !respData.body.token) {
						self.setConnectionStatus(false)
						return Callback('No token found', false)	
					}
					if (!respData.body.appData) {
						self.setConnectionStatus(false)
						return Callback('No user data found', false)
					}
					userProperties.token = respData.body.token
					userProperties.appData = respData.body.appData
					self.userProperties = userProperties
					return self.Store.setUserProperties(userProperties, function (err, success) {
						if (err) {
							console.error(err)
							self.setConnectionStatus(false)
							return Callback(err, false)
						}
						self.setConnectionStatus(true)
						return Callback(null, true)
					})
				})
			})
		}
		return Callback(null, true)
	} catch (err) {
		return Callback(err)
	}
};


User.prototype.showWarnings = function (router, Callback) {
	var self = this
	//
	return self.getProperties(function (err, userProps) {
		if (err) {
			console.error(err)
		}
		if (userProps.appData.campaigns && userProps.appData.campaigns.length > 0) {
			var modalButton = document.querySelector('#modalButton')
			var errModalContent = document.querySelector('#error-modal-content > ul')
			var paymentsArr = []
			userProps.appData.campaigns.forEach(function (campaign) {
				campaign.reservations.forEach(function (reservation) {
					reservation.payments.forEach(function (payment) {
						if (payment.message && payment.message.length > 0 && payment.message_status == 1) {
							paymentsArr.push(payment)
							self.errArr.push(payment.message);
						}
					})
				})
			})
			if (self.errArr.length > 0) {
				for (var i in self.errArr) {
					var element = document.createElement('LI')
					var err = document.createTextNode(self.errArr[i])
					element.appendChild(err)
					errModalContent.appendChild(element)
				}
				self.errArr = []
				modalButton.click()
					var acknowlegdeButton = document.querySelector('#acknowlegdeButton')
					acknowlegdeButton.addEventListener('click', function (e) {
					var data = {
						token: userProps.token,
						paymentsArr: paymentsArr
					}
					try {
						return self.ApiInterface.acknowledgeMessages(data, function (ApiErr, respStatus, respData) {
							if ((respStatus >= 400 && respStatus < 500) || ApiErr) {
								delete userProps.token
								if (ApiErr) {
									console.log(ApiErr)
								}
								return self.Store.setUserProperties(userProps, function (err, success) {
									if (err) {
										console.error(err)
									}
									return Callback(ApiErr, respStatus, respData)
								})
							}
							// 
							if(userProps && respData && respData.body && respData.body.token) {
								userProps.token = respData.body.token
								return self.Store.setUserProperties(userProps, function (err, success) {
									if (err) {
										console.error(err)
									}
									return Callback(null, respStatus, respData)
								}) 
							}
							return Callback('Erreur inconnue', respStatus)
						})
					} catch (err) {
						console.error(err)
						return self.disconnect(router)
					}
				})
			}
		}		
	})
}


User.prototype.showCurrentMedia = function (Callback) {
	return this.Store.retrieveUserProperties(function (err, userProps) {
		if (err) {
			return Callback(err)
		}
		if (!userProps || !userProps.appData || !userProps.appData.slot_limit) {
			return Callback('err: User properties incomplete !')
		}
		if (!userProps.appData.medias) {
			return Callback(null, [], userProps.appData.slot_limit)
		}
		return Callback(null, userProps.appData.medias, userProps.appData.slot_limit)
	})
}


module.exports = function (APP_NAME, NODE_ENV, Store, Helper) {
  return new User(APP_NAME, NODE_ENV, Store, Helper)
}



//////////////////
// WEBPACK FOOTER
// ./~/annonces-app-modules/controllers/User.js
// module id = 81
// module chunks = 0